<script>
    let connected = false
    let msgSend = ""

    const protocol = "wss"
    const host = "10.118.220.81"
    const port = "61607"

    let msg = "<div>Attempting to connect...</div>"

    const ws = new WebSocket(`${protocol}://${host}:${port}`)
    ws.addEventListener("open", e=> {
        connected = true
        msg += "<div style='font-weight: bold'>Connected to ws server</div>"
        ws.send("Hi Quintin!")
    })

    ws.addEventListener("close", ()=> {
        connected = false
        msg += "<div style='font-weight: bold'>Connection to ws server closed</div>"
    })

    ws.addEventListener("message", e=> {
        msg += "<div>Message from Quintin: " + e.data + "</div>"
        console.log("Message from Quintin: " + e.data)
    })

    ws.addEventListener("error", e=> {
        msg += "<div style='font-weight:bold; color: red;'>Error: " + JSON.stringify(e, ["message", "arguments", "type", "name"]) + "</div>"
        console.error(e)
    })
    
    function handleSubmit() {
        ws.send(msgSend)
        msg += "<div>MSG: " + msgSend + "</div>"
    }
</script>

<section id="fields" class="dash-details">
    <div>
        <h1>WebSocket Test</h1>

        <h2>Messages</h2>
        {@html msg}
        {#if connected}
            <form on:submit|preventDefault={handleSubmit}>
                <label for='msg'>Message: </label><input id="msg" type="text" bind:value={msgSend}>
                <button>Send</button>
            </form>
        {/if}
    </div>
</section>